import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';

import {
  getObject,
  getShowSummaryWindow,
  getIsAccount,
} from './reducer';

import { loadSettings } from '../../modules/Dashboard/DashboardActions';

import SurveyList from '../../modules/Feedback/components/opportunity-box/RequestTab';


import {
  closeSummaryWindow,
} from './actions';

class SummaryWindow extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.closeModal = this.closeModal.bind(this);
    this.requestAddContact = this.requestAddContact.bind(this);
  }

  componentWillMount() {
    this.props.dispatch(loadSettings(null, this.props.isAccount));
  }

  closeModal() {
    this.props.dispatch(closeSummaryWindow());
  }
  requestAddContact() {
    this.props.requestAddContact(this.props.object);
  }

  renderTitle() {
    const { object } = this.props;
    if (object && object.name) {
      return `Requested Feedback for ${object.name}`;
    }
    return 'Requested Feedback:';
  }

  renderContent() {
    return (
      <div>content</div>
    );
  }

  render() {
    const { show, object } = this.props;
    return (
      <Modal show={show} bsSize="lg" onHide={this.closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>{this.renderTitle()}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SurveyList
            eventKey="summary-window"
            title=""
            object={object}
            totalRequests={object.requested_feedbacks}
            isTab={false}
            showAddButton={false}
            requestCancelContact={this.props.requestCancelContact}
            requestShowOutreachPlan={this.props.requestShowOutreachPlan}
            requestChangeSenderEmail={this.props.requestChangeSenderEmail}
            requestChangeLanguage={this.props.requestChangeLanguage}
          />
        </Modal.Body>
        <Modal.Footer>
          <div className="clearfix">
            <Button className="pull-left" bsStyle="primary" onClick={this.requestAddContact}>Ask For Feedback</Button>
            <Button className="pull-right" bsStyle="default" onClick={this.closeModal}>Done</Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}


SummaryWindow.propTypes = {
  dispatch: PropTypes.func.isRequired,
  object: PropTypes.shape({}).isRequired,
  isAccount: PropTypes.bool,
  show: PropTypes.bool.isRequired,
  requestCancelContact: PropTypes.func,
  requestShowOutreachPlan: PropTypes.func,
  requestChangeSenderEmail: PropTypes.func,
  requestChangeLanguage: PropTypes.func,
  requestAddContact: PropTypes.func,
};
SummaryWindow.defaultProps = {
  isAccount: false,
  requestCancelContact: () => {},
  requestShowOutreachPlan: () => Promise.reject(new Error('Need handler')),
  requestChangeSenderEmail: () => Promise.reject(new Error('Need handler')),
  requestChangeLanguage: () => Promise.reject(new Error('Need handler')),
  requestAddContact: () => {},
};
function mapStateToProps(state) {
  const object = getObject(state) || {};
  const isAccount = getIsAccount(state);

  return {
    object,
    show: getShowSummaryWindow(state),
    isAccount,
  };
}
export default connect(mapStateToProps)(SummaryWindow);
